import { configurationKeys, type WorkspaceKey } from '@festina-life/api'
import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'

import { useAvailableServersForConfiguration } from '../../../../system/useAvailableServersForConfiguration'
import { fetchAllWorkspaceBranchChangesetsKey } from '../../../../uiModels/api/keys'

export const useInvalidateWorkspaceAfterHistoryRewrite = () => {
  const queryClient = useQueryClient()
  const allServers = useAvailableServersForConfiguration()

  return useCallback(
    async (workspaceKey: WorkspaceKey) => {
      await queryClient.invalidateQueries({
        queryKey: fetchAllWorkspaceBranchChangesetsKey({
          componentName: workspaceKey.branchKey.server,
          workspaceName: workspaceKey.name,
          baseBranchName: workspaceKey.branchKey.name,
        }),
      })

      await queryClient.invalidateQueries({
        queryKey: configurationKeys.fetchWorkspaceAllErrorsKeyPrefix({
          server: workspaceKey.branchKey.server,
          workspaceName: workspaceKey.name,
        }),
      })

      await queryClient.invalidateQueries({
        queryKey: configurationKeys.fetchAllConciseWorkspacesKey(allServers),
      })

      await queryClient.invalidateQueries({
        queryKey: configurationKeys.fetchConciseWorkspaceKeyPrefix({
          server: workspaceKey.branchKey.server,
          workspaceName: workspaceKey.name,
        }),
      })
    },
    [queryClient, allServers],
  )
}
